<template>
  <v-container fluid id="container_attandance_teacher">
    <v-card :loading="loading">
      <v-form>
        <v-container>
          <fieldset>
            <legend>Tutor Attendance Report</legend>
            <v-row class="ml-minus-18">
              <v-col cols="12" sm="4" md="4">
                <CustomerDatePicker @updateDate="updateDate" />
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-row>
                  <v-col>
                    <user-list :type="'tutor'" @selectedUserid="selectUser" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn
                      @click="validateFirst"
                      :loading="loading"
                      color="#6A158E"
                      dark
                      >Submit</v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <tutor-table
              v-if="tutor_id != null || calendar_date_range != null"
              :tutor_id="tutor_id"
              :calendar_date_range="calendar_date_range"
              :key="showList"
            />
          </fieldset>
        </v-container>
      </v-form>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import Form from "../../../utils/form";
import BreadCrumbs from "../../BreadCrumbs";
import CustomerDatePicker from "../CustomerDatePicker";
import TutorTable from "./TeacherAttendanceList";
import UserList from "../UserList";

export default {
  name: "tutor-attendance-report",
  components: {
    BreadCrumbs,
    CustomerDatePicker,
    TutorTable,
    UserList,
  },
  data() {
    return {
      selected_tutor: "",
      overlay: false,
      loading: false,
      tutors: [],
      errors: {},
      list: [],
      tutor_id: null,
      calendar_date_range: null,
      showList: false,
    };
  },

  methods: {
    updateDate(calendar_date_range) {
      this.calendar_date_range = calendar_date_range;
    },
    selectUser(value) {
      this.tutor_id = value;
    },
    validateFirst() {
      this.showList = !this.showList;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.app-bar--title {
  font-size: 15px;
}
#container_attandance_teacher {
  padding: 0px;
}
fieldset {
  border: 0;

  &:not(:last-of-type) {
    border-bottom: 1px dashed #8898aa80;
    margin-bottom: 20px;
  }

  & legend {
    font: Bold 20px/25px Lato;
    color: #172b4d;
  }
}

.page-heading {
  font: 300 22px/26px;
  font-family: "Gotham Narrow";
  color: #6a158e;
}
</style>
